import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import { UncontrolledAlert } from 'reactstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import TextField from 'material-ui/TextField';
import Checkbox from 'material-ui/Checkbox';
import { CircularProgress } from 'material-ui/Progress';
import Button from 'material-ui/Button';
import { FormControl, FormControlLabel } from 'material-ui/Form';
import Select from 'material-ui/Select';
import { MenuItem } from 'material-ui/Menu';
import Input, { InputLabel } from 'material-ui/Input';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import Switch from 'material-ui/Switch';

import ContainerHeader from '../../../components/ContainerHeader/index';
import { Card, CardBody, CardFooter, CardHeader, CardSubtitle, CardText } from 'reactstrap';

import * as assigneedetails from '../../../actions/assigneedetails';
import * as loadswitchercommittees from '../../../actions/teamdetails';

import MUISelector from "../../muiselector";

class AddAssignee extends Component {

    constructor(props) {
        super(props);
        this.state = {
            setValue: false,
            under_committtee_val: Number(this.props.loginUser.data.committee_id),
            id: this.props.params.id,
            assignee: { under_committtee_val: '', id: '', name: '', email_id: '', notify: 0 }
        };
    }

    componentDidMount() {
        this.props.actions.loadswitchercommittees();
        if (this.state.id > 0)
            this.props.actions.getAssigneeDetails(this.state.id);
        else
            this.state.elseassignee = { under_committtee_val: '', id: '', name: '', email_id: '', notify: 0 }
    }

    handleChange(field, e) {
        if (field == 'notify') {
            // console.log('this.state', this.state);
            const assignee = Object.assign({}, this.state.assignee, { [field]: e.target.checked ? 1 : 0 });
            this.setState(Object.assign({}, this.state, { 'assignee': assignee }));
        }
        else {
            const assignee = Object.assign({}, this.state.assignee, { [field]: e.target.value });
            this.setState(Object.assign({}, this.state, { 'assignee': assignee }));
        }
    }
    handleChangeTeam(e) {
        this.setState({ under_committtee_val: Number(e.target.value) })
        this.props.actions.getTeamUserList(e.target.value);

        this.props.loginUser.data.committee_id = e.target.value;
        this.props.actions.changePreferedTeamIdUser(this.props.loginUser.data)
    }

    handleSubmit(e) {
        e.preventDefault();
        this.state.assignee.under_committtee_val = this.state.under_committtee_val
        if (this.state.id > 0)
            this.props.actions.updateAssigneeDetails(this.state.assignee);
        else {
            this.props.actions.addAssigneeDetails(this.state.assignee);
        }
    }

    render() {
        const { match, loginUser, assigneeDetails, params, teamDetails } = this.props;
        // console.log('assigneeDetails', this.state.assignee)
        let result = null;
        if ((assigneeDetails && assigneeDetails.Status)) {
            result = <div className="loader-container"><CircularProgress color="secondary" size={50} /></div>
        }
        else if (assigneeDetails && assigneeDetails.assigneedetails && !this.state.setValue) {
            this.state.assignee = assigneeDetails.assigneedetails;
            this.state.setValue = true;
        }
        let _TeamList = null
        const committeeList = teamDetails.switchteamdetailsList;
        if (committeeList && committeeList.length > 0) {
            _TeamList = committeeList.map(team => (
                <MenuItem key={team.id} value={team.id}
                    style={{ fontWeight: '500' }}>
                    {team.name}
                </MenuItem>
            ))
            // this.setState({ under_committtee_val: loginUser.data.under_committtee_val })
        }
        return (
            <div className="slideInUpTiny ">
                {result}
                <ContainerHeader title="Add Assignee" match={match} />
                <div className="row mb-md-4">
                    <div className="col-12">
                        <FormControl className="w-100 mb-2 col-md-3">
                            <InputLabel htmlFor="age-simple">Team Switcher</InputLabel>
                            <Select
                                value={this.state.under_committtee_val}
                                onChange={this.handleChangeTeam.bind(this)}
                                input={<Input id="age-simple" />}
                                disabled={this.state.id ? true : false}
                            >
                                {_TeamList}
                            </Select>
                        </FormControl>
                        <ValidatorForm autoComplete="off" onSubmit={this.handleSubmit.bind(this)}>
                            <Card className="shadow border-0">
                                <CardHeader className="bg-primary text-white">Assignee Details</CardHeader>
                                <CardBody>
                                    <div className="row">
                                        <div className="col-4">
                                            <TextValidator margin="normal" className="mt-0 mb-2 col-12"
                                                name="assigneeName" label="Assignee Name"
                                                validators={['required', 'matchRegexp:^[a-zA-Z0-9-_ ]+$']}
                                                errorMessages={['This field is required','Only Alpha Numeric characters are allowed']}
                                                value={this.state.assignee.name} onChange={this.handleChange.bind(this, 'name')} />
                                        </div>
                                        <div className="col-4">
                                            <TextValidator type="text" margin="normal" className="mt-0 mb-2 col-12"
                                                name="email" label="Email Address"
                                                validators={['required', 'isEmail']}
                                                errorMessages={['This field is required', 'email is not valid']}
                                                value={this.state.assignee.email_id} onChange={this.handleChange.bind(this, 'email_id')} />
                                        </div>
                                        <div className="col-4">
                                            <FormControlLabel control={<Switch classes={{ checked: 'text-primary', bar: 'bg-primary', }}
                                                checked={this.state.assignee.notify > 0 ? true : false} onChange={this.handleChange.bind(this, 'notify')} />
                                            } label="Notifications" />
                                        </div>
                                    </div>

                                </CardBody>
                            </Card>
                            <div className="col-12 text-right">
                                <Button type='submit' variant="raised" className="jr-btn bg-primary text-white">Save</Button>
                                <Button variant="raised" className="jr-btn bg-grey text-white" onClick={() => { this.props.history.push('/assignee/assignee-list') }}>Cancel</Button>
                            </div>
                        </ValidatorForm>
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state, ownProps) {
    // console.log(ownProps)
    const { loginUser, teamDetails, assigneeDetails } = state;
    const { match } = ownProps;
    return { match, loginUser, teamDetails, assigneeDetails, params: ownProps.match.params }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, loadswitchercommittees, assigneedetails), dispatch)
    };
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AddAssignee));



// WEBPACK FOOTER //
// ./app/assigneedetails/addassignee/index.js